export const getCountryCode = async () => {
  try {
    const response = await fetch('https://ipinfo.io/json', { method: 'GET' })
    return await response.json()
  } catch (error) {
    console.error('Error fetching the country code:', error)
    return null
  }
}
